module.exports = __webpack_public_path__ + "img/30.f71b76fd.png";